import { useMutation, useQueryClient } from '@tanstack/react-query';
import { executePayment, PaymentRequest, PaymentResponse } from '@/api/wallet';

export const usePay = () => {
  const queryClient = useQueryClient();

  return useMutation<PaymentResponse, Error, PaymentRequest>({
    mutationFn: executePayment,
    onSuccess: () => {
      // 支払い成功時に残高と決済履歴を再取得
      queryClient.invalidateQueries({ queryKey: ['balance'] });
      queryClient.invalidateQueries({ queryKey: ['transactionHistory'] });
    },
  });
};
